import React, { useRef } from 'react';
import { ISchemaFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { NavItemTitle } from '../DataModelerNavUI';
import * as SecondaryNavUI from '../../../../components/SecondaryNav/SecondaryNavUI';
import { useIsSchemaStateDirty } from '../../DataModelerSchema/validation';
import { useAppSelector } from '../../../../redux/hooks';
import { defaultEmptyDraftEdits } from '../../../../redux/slices/dataModeler/dataModelerSlice';
import KubitTooltip from '../../../../components/KubitTooltip';
import Badge from '../../../../components/Badge';
import styled, { css } from 'styled-components';
import { optionHover } from '../../../../styles/shareableStyles';
import { SvgIcon } from '../../../../components/Icon';

interface IProps {
  schema: ISchemaFieldsFragment;
  isSelected: boolean;
  onSelectItem: (schemaId: string) => void;
}

const StyledLink = styled(SecondaryNavUI.StyledNavItem)<{
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  ${({ $isActive }) => $isActive && optionHover}
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.3;
    `}
`;

const SchemaModelNav = ({ schema, isSelected, onSelectItem }: IProps) => {
  const { isNew, isDirty } = useIsSchemaStateDirty(schema.id);
  const draftEdits =
    useAppSelector(
      (rootState) => rootState.dataModeler.schemaStates[schema.id]?.draftEdits,
    ) ?? defaultEmptyDraftEdits;
  const nameRef = useRef(null);
  const schemaName = draftEdits.updatedName ?? schema.name;
  const isDisabled =
    useAppSelector(
      (rootState) =>
        rootState.dataModeler.schemaStates[schema.id]?.draftEdits?.disabled,
    ) ?? schema.disabled;

  const iconName =
    isNew || isDirty || isDisabled ? 'folder-dashed' : 'folder-simple-star';

  return (
    <KubitTooltip content={schemaName} placement="top-start" noOpenDelay={true}>
      <StyledLink
        onClick={() => onSelectItem(schema.id)}
        $isActive={isSelected}
        $isDisabled={isDisabled}
        $isInteractive={true}
      >
        <SvgIcon name={iconName} customFill="currentColor" />

        <NavItemTitle ref={nameRef}>{schemaName}</NavItemTitle>
        {isNew ? (
          <Badge size="primary" color="blue">
            DRAFT
          </Badge>
        ) : isDirty ? (
          <Badge size="primary" color="blue">
            EDIT
          </Badge>
        ) : undefined}
      </StyledLink>
    </KubitTooltip>
  );
};

export default SchemaModelNav;
